import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment';
import Avatar from '../../../../shared/avatar';
import MentionTag from '../../../../shared/mention-tag';
import TolTag from '../../../../shared/tol-tag';
import DashboardContext from '../../context';

const Container = styled.div`
  padding: 16px 0;
  flex-grow: 5;
  width: 200px;
  display: flex;
  flex-direction: column;
`;

const MainArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 68px;
  flex-wrap: wrap;

  & > a > img {
    width: 40px;
    height: 40px;
    margin: 0 16px 24px 0;
    box-shadow: 0px 4px 8px rgba(50, 50, 71, .06), 0px 4px 4px rgba(50, 50, 71, .08);
  }
`;

const NameContainer = styled.div`
  display: flex;
  align-items: center;

  > span:first-of-type {
    margin-left: 24px;
  }
`;

const Name = styled.a`
  font: ${props => props.theme.fontWeightHeavy} 16px/120% ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.darkestGrey};
`;

const Title = styled.a`
  width: 100%;
  padding-right: 56px;
  margin-top: 4px;
  font: ${props => props.theme.fontWeightBold} 17px/120% ${props => props.theme.fontFamilyHeader};
  color: ${props => props.theme.bodyColor};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &&:hover {
    text-decoration: none;
    color: ${props => props.theme.bodyColor};
  }
`;

const PubDate = styled.span`
  margin-right: 20px;
  font: ${props => props.theme.fontWeightBold} 14px/130% ${props => props.theme.fontFamilyBody};
  color: ${props => props.theme.darkestGrey};
`;

const MinorRow = styled.div`
  width: 100%;
  margin-top: 4px;
  display: flex;
`;

export default function NewWireCard({
// eslint-disable-next-line no-unused-vars
  id, slug, contributorName, contributorSlug, contributorAvatarUrl, title, publishedDate, campaign,
}) {
  const { state: { contributors } } = React.useContext(DashboardContext);
  const selectedSlugs = contributors.filter(c => c.selected).map(c => c.slug);
  const shouldShowMentionIndicator = selectedSlugs.length > 0
    && _.indexOf(selectedSlugs, contributorSlug) < 0;

  const avatarProps = {
    slug: contributorSlug,
    profilePictureUrl: contributorAvatarUrl,
    name: contributorName,
  };

  return (
    <Container>
      <MainArea>
        <Avatar {...avatarProps} />
        <NameContainer>
          <Name href={`/contributors/${contributorSlug}`}>{contributorName}</Name>
          {shouldShowMentionIndicator && <MentionTag />}
          {!!campaign && <TolTag {...campaign} />}
        </NameContainer>
        <Title href={`/wires/${slug}`}>{title}</Title>
        <MinorRow>
          <PubDate>{moment(publishedDate).format('Do MMM, YY')}</PubDate>
        </MinorRow>
      </MainArea>
    </Container>
  );
}

NewWireCard.propTypes = {
  id: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  contributorName: PropTypes.string.isRequired,
  contributorAvatarUrl: PropTypes.string,
  contributorSlug: PropTypes.string.isRequired,
  publishedDate: PropTypes.string.isRequired,
  campaign: PropTypes.shape({
    name: PropTypes.string.isRequired,
    sentDate: PropTypes.string.isRequired,
  }),
};

NewWireCard.defaultProps = {
  contributorAvatarUrl: null,
  campaign: null,
};
